// Organization configuration
// Centralized mapping of organization identifiers
// TODO: Move to environment variables or database lookup for true multi-tenancy

export interface OrganizationConfig {
  id: string
  name: string
  subdomain: string
  customDomain?: string
  primaryColor: string
  logoUrl?: string
}

// Known organization IDs
// These should eventually be loaded from database or environment
export const KNOWN_ORGS = {
  FTH: 'e3f1d125-515f-4c04-ad6e-869660e1b39f',
  NORTHSTAR_DEMO: '33333333-3333-3333-3333-333333333333',
  DEFAULT: '33333333-3333-3333-3333-333333333333',
} as const

// Organization configurations
export const ORG_CONFIGS: Record<string, OrganizationConfig> = {
  [KNOWN_ORGS.FTH]: {
    id: KNOWN_ORGS.FTH,
    name: 'Full Tilt Hockey',
    subdomain: 'fth',
    customDomain: 'fulltilthockey.com',
    primaryColor: '#000000',
    logoUrl: 'https://fulltilt-sand.vercel.app/assets/full_tilt_wordmark_white_rgb.svg',
  },
  [KNOWN_ORGS.NORTHSTAR_DEMO]: {
    id: KNOWN_ORGS.NORTHSTAR_DEMO,
    name: 'Northstar Hockey Academy',
    subdomain: 'demo',
    primaryColor: '#0F4C81',
  },
}

// Helper to get org config by ID
export function getOrgConfig(orgId: string): OrganizationConfig | undefined {
  return ORG_CONFIGS[orgId]
}

// Helper to get org ID from subdomain
export function getOrgIdBySubdomain(subdomain: string): string | undefined {
  const entry = Object.entries(ORG_CONFIGS).find(
    ([, config]) => config.subdomain === subdomain
  )
  return entry?.[0]
}

// Helper to get org ID from custom domain
export function getOrgIdByDomain(domain: string): string | undefined {
  const entry = Object.entries(ORG_CONFIGS).find(
    ([, config]) => config.customDomain === domain ||
                   `www.${config.customDomain}` === domain
  )
  return entry?.[0]
}

// Check if an org ID matches a known org
export function isKnownOrg(orgId: string, knownOrg: keyof typeof KNOWN_ORGS): boolean {
  return orgId === KNOWN_ORGS[knownOrg]
}
